'use client';

import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';

import { env } from '@/env';
import { SimpleOopsFallback } from '@/components/errors/simple-oops-fallback';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    if (env.NEXT_PUBLIC_SENTRY_DSN) {
      Sentry.captureException(error);
    }
  }, [error]);

  return <SimpleOopsFallback onRetry={reset} />;
}
